import React, { useState } from 'react'
import {
    useNavigate,
    useParams
} from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import './navigating.css'
import { getUserData, getUserProfile } from '../../redux/actions/login'
import Loader from '../../components/global/Loader'
import URL from '../../constants/urls'
import { useEffect } from 'react'
import { getPartnerDetailsBySLug, globalKeyStore } from '../../redux/actions/globalState'
import {
    EMPTY_ARRAY,
    EMPTY_OBJECT
} from '../../constants/globalConstants'

function Navigating(props) {
    const { acc, ref,
        partner,
        masquerade } = useParams()
    const {
        dispatch,
        isFetching,
        partnerDetails
    } = props
    const navigate = useNavigate()
    const [loading
        , setLoading
    ] = useState(true)

    useEffect(() => {
        // localStorage.clear()
        const userData = {}
        if ((acc && acc != 0) && (ref && ref != 0)) {
            userData.access_token = acc
            userData.refresh_token = ref
        }

        localStorage.setItem('userData', JSON.stringify(userData))

        if (masquerade && masquerade != '') {
            localStorage.setItem('masquerade', masquerade)
        } else {
            localStorage.removeItem('masquerade')
        }
    }, [EMPTY_OBJECT])

    useEffect(() => {
        if (partner) {
            setLoading(true)
            // localStorage.setItem('partnerSecret', secret)
            dispatch(getPartnerDetailsBySLug(partner)).then((res) => {
                localStorage.setItem('partnerData', JSON.stringify(res?.data))
                const partnerData = partnerDetails
                const color = partnerData?.brand_setting?.color
                if (partnerData?.brand_setting && partnerData?.brand_setting?.color) {
                    document.documentElement.style.setProperty('--bs-primary', color)
                    document.documentElement.style.setProperty('base-color', color)
                    document.documentElement.style.setProperty('primary', color)
                    document.documentElement.style.setProperty('textcolor', color)
                    document.documentElement.style.setProperty('--bs-btn-bg', color)
                    document.documentElement.style.setProperty('--bs-primary-rgb', '34, 32, 93')
                    document.documentElement.style.setProperty('--bs-list-group-active-border-color', color)
                    document.documentElement.style.setProperty('--bs-list-group-active-color', color)
                    document.documentElement.style.setProperty('--bs-list-group-active-bg', color)
                }
                if ((acc && acc != 0) && (ref && ref != 0)) {
                    localStorage.setItem('isLoggedIn', true)
                    dispatch(globalKeyStore({ isLoading: false, isLoginModal: false, isLoggedIn: true }))
                    dispatch(getUserData()).then((res) => {
                        if (res?.email) {
                            dispatch(getUserProfile()).then((res) => {
                                if (res) {
                                    setLoading(false)
                                    const userProfileData = JSON.parse(localStorage.getItem('userData'))
                                    userProfileData.user = res
                                    if (userProfileData) {
                                        localStorage.setItem('userData', JSON.stringify(userProfileData))
                                        navigate(`/${partnerData?.slug ? partnerData?.slug : partner}${URL?.INDEX}`)
                                        navigate(0)
                                    } else {
                                        localStorage.setItem('userData', '{}')
                                    }
                                } else {
                                    navigate(`/${partnerData?.slug ? partnerData?.slug : partner}${URL?.INDEX}`)
                                    navigate(0)
                                    // localStorage.removeItem('userData')
                                }
                            }).catch(() => {
                                navigate(`/${partnerData?.slug ? partnerData?.slug : partner}${URL?.INDEX}`)
                                navigate(0)
                                localStorage.removeItem('userData')
                            })

                        } else {
                            navigate(`/${partnerData?.slug ? partnerData?.slug : partner}${URL?.INDEX}`)
                            navigate(0)
                            // localStorage.removeItem('userData')
                        }
                    }).catch(() => {
                        navigate(`/${partnerData?.slug ? partnerData?.slug : partner}${URL?.INDEX}`)
                        navigate(0)
                        localStorage.removeItem('userData')
                    })
                } else {
                    navigate(`/${partnerData?.slug ? partnerData?.slug : partner}`)
                    // navigate(0)
                }
            }).catch(() => {
            })
        } else {
            localStorage.removeItem('partnerSecret')
        }



    }, [EMPTY_ARRAY])
    return (
        <div className="d-flex justify-content-center align-items-center loaderDivHeight">
            {isFetching || loading && <Loader
                eventsLoader={true}
            />}
        </div>
    )
}

Navigating.propTypes = {
    dispatch: PropTypes.func,
    isFetching: PropTypes.bool,
    partnerDetails: PropTypes.object,
}

Navigating.defaulProps = {
    dispatch: noop,
    isFetching: true,
    partnerDetails: EMPTY_OBJECT,
}

function mapStateToProps({
    globalReducers
}) {
    return {
        isFetching: globalReducers?.isFetching,
        partnerDetails: globalReducers?.partnerDetails

    }
}
export default connect(mapStateToProps)(Navigating)